// Converts "Some sTRing" to "some-string"
angular.module('pl-shared')
  .filter('simplePlural', function(_) {
    return function(input, count) {
      if (typeof input !== 'string') return ''
      var showPlural = (arguments.length === 1 || count !== 1) && !input.endsWith('s')
      return showPlural ? input + 's' : input
    }
  })
